import HCPMarketingBanner from "../elements/hcp-marketing/main-banner";
import PatientBanner from "../../images/banner/patient-banner.jpg";
import { PatientAdvantages } from "../elements/patient-marketing/patient-advantages";
import { ManagedServices } from "../elements/hcp-marketing/managed-services";
import { ContactSection } from "../elements/contact-section";
import { PatientStrategy } from "../elements/patient-marketing/patient-strategy";
import { PatientTargetAdvantages } from "../elements/patient-marketing/patient-targeting-advantages";
export const PatientMarketing = () => {
  return (
    <section>
      <HCPMarketingBanner
        title="Patient Marketing"
        topic="Digital Marketing & Advertising to Reach Patients based on specific conditions"
        description="Reaching patients while staying HIPAA compliant can be complex — but you don’t have to do it alone. Now you have a partner who understands how to safely and effectively navigate patient targeting.<br/> <br/>By combining multiple data sources — including tokenized claims data (100% HIPAA compliant), self-reported patient insights, and contextual engagement data from online behavior — we enable precise targeting by condition. This multi-layered approach ensures you're connecting with the right patient audience, at the right time, in a fully compliant and meaningful way."
        image={PatientBanner}
      />
      <PatientAdvantages />
      <PatientTargetAdvantages />
      <PatientStrategy />

      <ManagedServices description="If you're new to using data for better patient digital marketing outcomes — don’t worry. We offer full support throughout each campaign, so you’ll gain clear insights into performance and always know your next steps for success." />
      <ContactSection />
    </section>
  );
};
